/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GoalsOfTreatmentResponseDto,
  GoalsOfTreatmentUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GoalsOfTreatmentResponseDtoFromJSON,
    GoalsOfTreatmentResponseDtoToJSON,
    GoalsOfTreatmentUpsertRequestDtoFromJSON,
    GoalsOfTreatmentUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetGoalsOfTreatmentByPatientIdRequest {
    patientId: string;
}

export interface UpsertGoalsOfTreatmentRequest {
    goalsOfTreatmentUpsertRequestDto: GoalsOfTreatmentUpsertRequestDto;
}

/**
 * 
 */
export class PatientGoalsOfTreatmentApi extends runtime.BaseAPI {

    /**
     * Get patient\'s goals of treatment information
     */
    async getGoalsOfTreatmentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalsOfTreatmentResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/goals-of-treatment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalsOfTreatmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s goals of treatment information
     */
    async getGoalsOfTreatment(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalsOfTreatmentResponseDto> {
        const response = await this.getGoalsOfTreatmentRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s goals of treatment information by patient ID
     */
    async getGoalsOfTreatmentByPatientIdRaw(requestParameters: GetGoalsOfTreatmentByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoalsOfTreatmentResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getGoalsOfTreatmentByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/goals-of-treatment/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoalsOfTreatmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s goals of treatment information by patient ID
     */
    async getGoalsOfTreatmentByPatientId(requestParameters: GetGoalsOfTreatmentByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoalsOfTreatmentResponseDto> {
        const response = await this.getGoalsOfTreatmentByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s goals of treatment information
     */
    async upsertGoalsOfTreatmentRaw(requestParameters: UpsertGoalsOfTreatmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['goalsOfTreatmentUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'goalsOfTreatmentUpsertRequestDto',
                'Required parameter "goalsOfTreatmentUpsertRequestDto" was null or undefined when calling upsertGoalsOfTreatment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/goals-of-treatment`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GoalsOfTreatmentUpsertRequestDtoToJSON(requestParameters['goalsOfTreatmentUpsertRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create patient\'s goals of treatment information
     */
    async upsertGoalsOfTreatment(requestParameters: UpsertGoalsOfTreatmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertGoalsOfTreatmentRaw(requestParameters, initOverrides);
    }

}
